import { render, staticRenderFns } from "./SocioSelect.vue?vue&type=template&id=3732d7cd"
import script from "./SocioSelect.vue?vue&type=script&lang=js"
export * from "./SocioSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports